import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillTosDataView } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTos from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTos";
import translate from "@insite/client-framework/Translate";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";
import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown";
// import React, { FC, useEffect, useState } from "react"; // Store Custom Code
import { connect, ResolveThunks } from "react-redux";

/* Store Custom Code - Start */
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import BillToSelection from "@store/Components/Customer/BillToSelection";
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";
/* Store Custom Code - End */

interface OwnProps {
    noShipToAndCantCreate: boolean;
    setParameter: (parameter: GetBillTosApiParameter) => void;
    parameter: GetBillTosApiParameter;
    billTo?: BillToModel;
    onSelect: (billTo: BillToModel) => void;
    extendedStyles?: ChangeCustomerBillToSelectorStyles;
    isLoading?: boolean;
}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => ({
    billTosDataView: getBillTosDataView(state, props.parameter),
    customerSettings: getSettingsCollection(state).customerSettings,
});

const mapDispatchToProps = {
    loadBillTos,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ChangeCustomerBillToSelectorStyles {
    billToSelectorDynamicDropdown?: DynamicDropdownPresentationProps;
    // Store Custom Code
    loadingSpinner?: LoadingSpinnerProps;
}

export const changeCustomerBillToSelectorStyles: ChangeCustomerBillToSelectorStyles = {
    // Store Custom Code
    loadingSpinner: {
        css: css`
            margin: 3em auto;
        `,
    },
};

const ChangeCustomerBillToSelector: FC<Props> = ({
    noShipToAndCantCreate,
    parameter,
    setParameter,
    billTo,
    onSelect,
    extendedStyles,
    isLoading,
    billTosDataView,
}) => {
    const [styles] = useState(() => mergeToNew(changeCustomerBillToSelectorStyles, extendedStyles));
    const [options, setOptions] = useState<OptionObject[]>([]);
    const [currentBillTo, setCurrentBillTo] = useState(""); // Store Custom Code
    const [billToValues, setBillToValues] = useState<BillToModel[]>([]); // Store Custom Code

    useEffect(() => {
        if (billTosDataView.value) {
            /* Store Custom Code - Start */
            const billTo: Array<BillToModel> = billTosDataView.value;
            setBillToValues(billTo);
            /* Store Custom Code - End */

            const options: OptionObject[] = billTosDataView.value.map(billTo => ({
                optionText: billTo.label,
                optionValue: billTo.id,
            }));
            setOptions(options);
        }
    }, [billTosDataView]);

    const searchTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setParameter({
            ...parameter,
            filter: event.currentTarget.value,
        });
    };

    const selectCustomerHandler = (billToId?: string) => {
        if (billTosDataView.value && billToId) {
            const billTo = billTosDataView.value.filter(billTo => billTo.id === billToId)[0];
            /* Store Custom Code - Start */
            if (billTo && billToId !== currentBillTo) {
                setCurrentBillTo(billToId);
                onSelect(billTo as BillToModel);
            }
            /* Store Custom Code - End */
        }
    };

    /* Store Custom Code - Start */
    if (billTosDataView.isLoading || !billTosDataView.value) {
        return <LoadingSpinner {...styles.loadingSpinner} />;
    }
    /* Store Custom Code - End */

    return (
        /* Store Custom Code - Start */
        <BillToSelection
            currentBillTo={currentBillTo}
            selectCustomerHandler={selectCustomerHandler}
            billTosDataView={billTosDataView}
            setParameter={setParameter}
            parameter={parameter}
        />
        /* Store Custom Code - End */
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeCustomerBillToSelector);
